export default "__VITE_ASSET__DdGzcNFb__"